import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isOAuthApplicationResult = objectOf({
  name: string,
  redirect_uri: string,
  scopes: arrayOf(string),
  logo: anyOf(string, nullValidation),
  id: string,
});
